// SidebarData.js
const SidebarData = [
    {   
        id: 1,
        label: "Menu",
        isMainMenu: true,
    },
    {
        id: 2,
        label: "Dashboard",
        icon: "mdi mdi-home-variant-outline",
        url: "/dashboard",
        issubMenubadge: true,
        bgcolor: "bg-primary",
    },
    {
        id: 3,
        label: "Users",
        icon: "bi bi-person-circle",
        url: "/users",
        issubMenubadge: true,
        bgcolor: "bg-primary",
    },
    {
        id: 4,
        label: "Manufacturer / Vendors",
        icon: "mdi mdi-account-multiple",
        url: "/vendors",
        issubMenubadge: true,
        bgcolor: "bg-primary",
    },
    {
        id: 5,
        label: "Reseller / Distributors",
        icon: "mdi mdi-account-multiple",
        url: "/distributors",
        issubMenubadge: true,
        bgcolor: "bg-primary",
    },
    {
        id: 6,
        label: "Customers",
        icon: "mdi mdi-account-group-outline",
        url: "/customers",
        issubMenubadge: true,
        bgcolor: "bg-primary",

    },
    {
        id: 7,
        label: "Products",
        icon: "mdi mdi-briefcase",
        url: "/products",
        issubMenubadge: true,
        bgcolor: "bg-primary",

    },
    // {
    //     id: 8,
    //     label: "Supported products",
    //     icon: "mdi mdi-briefcase",
    //     url: "/supported-products",
    //     issubMenubadge: true,
    //     bgcolor: "bg-primary",
    // },
    {
        id: 9,
        label: "Product certification",
        icon: "bi bi-patch-check-fill",
        url: "/product-certification",
        issubMenubadge: true,
        bgcolor: "bg-primary",
    },
    {
        id: 10,
        label: "Quotations",
        icon: "bi bi-chat-right-quote-fill",
        url: "/quotations",
        issubMenubadge: true,
        bgcolor: "bg-primary",
    },
    {
        id: 11,
        label: "Application settings",
        icon: "bi bi-gear-fill  ",
        // issubMenubadge: true,
        // url : '/#',
        bgcolor: "bg-primary",
        subItem: [
            { id : 1, sublabel: "Settings", link: "/settings" },
            { id : 2, sublabel: "Taxation", link: "/taxations" },
            
        ],
    },
    // {
    //     id : 13,
    //     label: "Test",
    //     icon: "mdi mdi-finance",
        
    // },
];

export default SidebarData;
